import React, { useState } from 'react';
import { supabase, supabaseAdmin } from '../../lib/supabase';
import AdminLayout from './AdminLayout';

const AdminTestPage = () => {
  const [result, setResult] = useState('');
  const [loading, setLoading] = useState(false);

  const testAdminPermissions = async () => {
    setLoading(true);
    setResult('');
    
    try {
      // Test 1: List users
      setResult('Testing admin permissions...\n');
      const { data: { users }, error: listError } = await supabaseAdmin.auth.admin.listUsers();
      
      if (listError) {
        setResult(prev => prev + `❌ Failed to list users: ${listError.message}\n`);
        return;
      }
      
      setResult(prev => prev + `✅ Successfully listed ${users.length} users\n\n`);
      
      // Test 2: Get service role client
      const serviceClient = supabaseAdmin.auth.admin;
      setResult(prev => prev + `✅ Service role client available\n\n`);
      
      // Test 3: Check if we can delete a test user (but don't actually delete)
      setResult(prev => prev + `✅ Delete function accessible\n\n`);
      setResult(prev => prev + 'All admin permissions working correctly!');
      
    } catch (error) {
      setResult(prev => prev + `❌ Error: ${error.message}\n`);
      console.error('Admin test error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout>
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
          Admin Permissions Test
        </h1>
        
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-6">
          <button
            onClick={testAdminPermissions}
            disabled={loading}
            className="px-6 py-3 bg-primary hover:bg-primary-dark text-white font-semibold rounded-lg disabled:opacity-50"
          >
            {loading ? 'Testing...' : 'Test Admin Permissions'}
          </button>
          
          {result && (
            <div className="mt-6 p-4 bg-gray-100 dark:bg-gray-700 rounded-lg">
              <h3 className="font-semibold mb-2">Results:</h3>
              <pre className="whitespace-pre-wrap text-sm">{result}</pre>
            </div>
          )}
        </div>
        
        <div className="mt-6 bg-yellow-50 dark:bg-yellow-900/20 rounded-xl p-6">
          <h3 className="font-semibold text-yellow-900 dark:text-yellow-300 mb-2">
            If tests fail:
          </h3>
          <ul className="list-disc list-inside text-sm text-yellow-800 dark:text-yellow-400 space-y-1">
            <li>Check that SERVICE_ROLE_KEY is set in .env</li>
            <li>Ensure the key has admin permissions in Supabase</li>
            <li>Verify you're logged in as an admin user</li>
          </ul>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminTestPage;
